import { getCurrentChatInput, useIsDummyChat, useSetChatOnboardingStep } from '../store'
import { useMessageListScrollActions } from '../components'
import { useSubmitMessage } from './useSubmitMessage'
import { SendMessageOptions } from '../types'
import { useCallback } from 'react'

export const useSubmitChatInput = () => {
  const isDummyChat = useIsDummyChat()
  const submitMessage = useSubmitMessage()
  const { scrollToEnd } = useMessageListScrollActions()
  const setChatOnboardingStep = useSetChatOnboardingStep()

  return useCallback(
    (options?: SendMessageOptions) => {
      const chatInput = getCurrentChatInput()
      if (chatInput.length === 0) {
        return
      }

      if (isDummyChat) {
        window.ampltd.trackEvent('Dummy chat message', {
          length: chatInput.length,
        })
      }

      submitMessage(chatInput, options)

      scrollToEnd()
      setChatOnboardingStep('completed')
    },
    [isDummyChat, submitMessage, setChatOnboardingStep, scrollToEnd],
  )
}
